import { render, staticRenderFns } from "./Webpage.vue?vue&type=template&id=76a5b4ee"
import script from "./Webpage.vue?vue&type=script&lang=js"
export * from "./Webpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports